import { pb } from "@/lib/pb";

/**
 * The native side of the home-screen widgets, when there is one.
 *
 * The Android app injects `window.KoboWidget` (src-tauri/gen/android
 * KoboWidgets.kt). The widgets read the Kobo server on their own, so all they
 * need from here is the server URL and the login token, handed over whenever
 * the session changes. Everywhere else the object is absent and this is a no-op.
 * The iOS widget will take the same two values (docs/ios-widgets.md).
 */
type WidgetBridge = {
  saveAuth(baseUrl: string, token: string): void;
  clear(): void;
  refresh(): void;
};

function bridge(): WidgetBridge | null {
  return (window as unknown as { KoboWidget?: WidgetBridge }).KoboWidget ?? null;
}

export function startWidgetBridge(): void {
  const native = bridge();
  if (!native) return;
  const sync = () => {
    if (pb.authStore.isValid && pb.authStore.token) native.saveAuth(pb.baseURL, pb.authStore.token);
    else native.clear();
  };
  sync();
  pb.authStore.onChange(sync);
  // Leaving the app is when a just-ticked task should reach the home screen.
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") native.refresh();
  });
}
